import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import UserForm from "@components/forms/UserForm";

const AddEditUser = () => {
  const params = useParams()
  const { userId } = params

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Administrar de Usuario"
      backUrl="/user/acl/users"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "user",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <UserForm
        id={userId}
        formId="user"
        saveRedirectUrl="/user/acl/users"
      />
    </PageContainer>
  );
}

export default AddEditUser;
